import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
// import CKeditorComponent from "../../../components/cKeditor/CKeditor";
import useAuth from "../../../hooks/useAuth";

const ArticleSinglePage = () => {
  const { authenticated } = useAuth();
  const params = useParams();
  const axiosPrivate = useAxiosPrivate();
  const [post, setPost] = useState();
  const [isLoading, setisLoading] = useState(true);
  const [pubServerDate, setpubServerDate] = useState();

  const [title, setTitle] = useState("");
  const [titleUrl, setTitleUrl] = useState("");
  const [ckData, setckData] = useState("");
  const [date, setDate] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getSingleArticles = async () => {
      const res = await axiosPrivate.get(
        `article/singleArticle/${params.string}`,
        {
          withCredentials: true,
          signal: controller.signal,
        }
      );
      console.log(res.data);
      console.log(authenticated);
      if (res.data?.articles?.user?._id !== authenticated?.user._id) {
        console.log(res.data?.articles?.user?._id, "user");
        navigate("/dashboard/list-articles");
      }

      setPost(res.data?.articles);
      const article = res.data?.articles;
      if (article) {
        reset(article); // Populate the form with fetched data
        setDate(article.pubDate); // Set initial date value
        setTitleUrl(article.titleSlug);
        setckData(article.articleData);
        console.log(article.articleData);
      }
      setisLoading(false);
    };
    getSingleArticles();

    return () => {
      isMounted = false;
      controller.abort();
      setisLoading(false);
    };
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();
  const CategoryData = ["news", "videos"];
  const HTMLData = ["NO", "YES"];

  const handleUpdateDateTime = (e) => {
    e.preventDefault();
    const newdate = new Date();

    const Datemy =
      newdate.getDate() +
      "-" +
      (newdate.getMonth() + 1) +
      "-" +
      newdate.getFullYear();

    const showTime =
      newdate.getHours() +
      ":" +
      newdate.getMinutes() +
      ":" +
      newdate.getSeconds();

    console.log("Today's Date:", Datemy);
    console.log("Current Time:", showTime);
    setDate(Datemy + " " + showTime);
    console.log(newdate);
    setpubServerDate(newdate);
  };

  useEffect(() => {
    const newdate = new Date();

    const Datemy =
      newdate.getDate() +
      "-" +
      (newdate.getMonth() + 1) +
      "-" +
      newdate.getFullYear();

    const showTime =
      newdate.getHours() +
      ":" +
      newdate.getMinutes() +
      ":" +
      newdate.getSeconds();

    console.log("Today's Date:", Datemy);
    console.log("Current Time:", showTime);

    setDate(Datemy + " " + showTime);
    setpubServerDate(newdate);

    // console.log(authenticated?.user)
  }, []);

  return (
    <>
      {/* <Breadcrumb pageName="Calendar" /> */}

      {/* <!-- ====== Create Section Start ====== --> */}
      <ToastContainer />

      <div className="flex justify-center gradient-Primary items-center py-5  rounded-xl shadow-lg mx-4">
        <h1 className="text-3xl font-bold text-white">Update Article</h1>
      </div>
      <div className="w-full max-w-full rounded-xl  bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <form
          id="create-article"
          onSubmit={handleSubmit(async (data) => {
            console.log("Onsubmit", data);
            // setDisabled(true);
            console.log(data.articleData, "this is data");
            const formData = {
              category: data.category,
              title: data.title,
              titleSlug: titleUrl,
              introduction: data.introduction,
              imageCopyright: data.imageCopyright,
              idImage: data.idImage,
              htmlfilters: data.htmlfilters,
              pubDate: date,
              pubServerDate: pubServerDate,
              articleData: data.articleData,
            };
            const articleUpdate = {
              _id: post._id,
              updatedData: formData,
            };
            console.log(articleUpdate, "this is updated data");

            await axiosPrivate
              .put("/article/updateArticle", articleUpdate, {
                withCredentials: true,
              })
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => console.log(err));
          })}
          className="my-4 p-4"
        >
          <input type="hidden" name="setmenu_name" />
          <input type="hidden" name="action" />

          <br />
          {/* <SelectGroupTwo     id="1" title="Category" dropdownData={CategoryData}/>
           */}
          <div>
            <label className="block">Category</label>
            <select {...register("category", {})} className="rounded border">
              <option value="" defaultValue={post?.category} disabled>
                Select Category
              </option>
              {CategoryData.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="my-3 block text-black dark:text-white">
              Title*
            </label>
            <input
              {...register("title")}
              type="text"
              onChange={(e) => {
                setTitle(e.target.value);
                const newTitle = e.target.value.replace(/ /g, "-");
                setTitleUrl(newTitle);
              }}
              placeholder="Default Input"
              className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
            />
          </div>

          <div>
            <label className="my-3 block text-black dark:text-white">
              Title Used for url
            </label>
            <input
              required
              value={titleUrl}
              disabled
              type="text"
              placeholder="Default Input"
              className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
            />
          </div>
          {/* <b>Twitter Link</b>
            <input type="text" name="twitter" value="" /> */}
          <div>
            <label className="my-3 block text-black dark:text-white">
              Introduction
            </label>
            <input
              {...register("introduction", {})}
              type="text"
              placeholder="Default Input"
              className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
            />
          </div>
          {/* <b>Linkedin Link</b>
            <input type="text" name="linkedin" value="" /> */}
          <div>
            <label className="my-3 block text-black dark:text-white">
              Image Copyright
            </label>
            <input
              {...register("imageCopyright", {})}
              type="text"
              placeholder="Default Input"
              className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
            />
          </div>
          <div>
            <label className="my-3 block text-black dark:text-white">
              ID Image
            </label>
            <input
              {...register("idImage")}
              type="number"
              defaultValue={-1}
              placeholder="Default Input"
              className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
            />
          </div>
          <div className="flex my-3 items-center">
            <div>
              <label className=" block text-black dark:text-white">
                Pub Date/Time :
              </label>
            </div>
            <div className="flex">
              <input
                {...register("pubDate")}
                value={date}
                type="text"
                onChange={(e) => {
                  setDate(e.target.value);

                  const [day, month, yearTime] = e.target.value.split("-");
                  const [year, time] = yearTime.split(" ");

                  // Create a new Date object
                  const dateObject = new Date(
                    `${month}-${day}-${year} ${time}`
                  );

                  setpubServerDate(dateObject);
                }}
                placeholder="Default Input"
                className="w-3/5 mx-2 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              />
              <button
                onClick={handleUpdateDateTime}
                className="inline-flex items-center justify-center rounded-md border border-primary py-1 px-10 text-center font-medium text-primary hover:bg-opacity-90 lg:px-8 xl:px-10"
              >
                {" "}
                Update
              </button>
            </div>
          </div>
          <label>Last Updated : </label>

          <div>
            <label className="block">HTML Filters</label>
            <select {...register("htmlfilters")} className="rounded border">
              <option value="" disabled>
                Select HTML
              </option>
              {HTMLData.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div className="mt-2">
            <h2>Article Page:</h2>
            {/* <div className="mt-5">
              <CKeditorComponent
                value={ckData}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //   setckData(data);

                  setValue("articleData", data); // Set the CKEditor data to the form
                }}
                // {...register("ckEditor")}
              />
            </div> */}
          </div>
          <div className="mt-3">
            {post?.user?._id == authenticated?.user?._id ? (
              <button
                type="submit"
                onClick={() => {}}
                className="inline-flex items-center justify-center rounded-md border border-primary py-1 px-10 text-center font-medium text-primary hover:bg-opacity-90 lg:px-8 xl:px-10"
              >
                Update Article
              </button>
            ) : (
              ""
            )}
          </div>
        </form>
      </div>
      {/* <!-- ====== Create Section End ====== --> */}
    </>
  );
};

export default ArticleSinglePage;
